import type {RoiSummary, RoiTimeUnit} from 'src/types/roi';

import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import meanBy from 'lodash/meanBy';
import memoize from 'lodash/memoize';

import BarChart from 'src/components/analytics/figures/bar-chart';
import {checkRoiV3ApiEnabled} from 'src/utils/analytics-api-migration';

import {prettifyNumber} from 'src/utils';

import css from '../index.css';


const NUM_DAYS_IN_MONTH = 30;

const PlacementDurationsChart = ({
  data,
  chartProps,
  loading,
  onUnitChange,
  timeUnit,
}: {
  data?: RoiSummary;
  chartProps?: unknown;
  loading?: boolean;
  onUnitChange: (timeUnit: RoiTimeUnit) => void;
  timeUnit: RoiTimeUnit;
}) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  return (
    <React.Fragment>
      <div className={css.subtitle}>
        {t('Average_Length_of_Assignment', 'Average Length of Assignment')}
        {/* @ts-expect-error - TS7030 - Not all code paths return a value. */}
        {(() => {
          if (data) {
            const placementDurationMean = getPlacementDurationMean(data);
            return `(${t('Overall', 'Overall')} ${placementDurationMean} ${t(
              'months',
              'months',
            )})`;
          }
        })()}
      </div>
      <BarChart
        // @ts-expect-error - TS2698 - Spread types may only be created from object types.
        {...chartProps}
        categoryKey={timeUnit}
        dataKey={
          checkRoiV3ApiEnabled() ? 'assignmentLength' : 'placementDurations'
        }
        loading={loading}
        showEmptyBars={false}
        color={css.colorOrange}
        data={data ? data.summaryStats : []}
        timeUnit={timeUnit}
        // @ts-expect-error - TS2769 - No overload matches this call.
        onUnitChange={onUnitChange}
        getTooltipText={({value}) =>
          `${t(
            'Average_assignment_length_of',
            'Average assignment length of',
          )} ${getDaysInMonths(value)} ${t('months', 'months')}`
        }
      />
    </React.Fragment>
  );
};

const _getPlacementDurationMean = (data: RoiSummary): number => {
  const keyName = checkRoiV3ApiEnabled()
    ? 'assignmentLength'
    : 'placementDurations';
  // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number'.
  return getDaysInMonths(
    // @ts-expect-error - TS2339 - Property 'assignmentLength' does not exist on type 'SummaryStat'. | TS2339 - Property 'placementDurations' does not exist on type 'SummaryStat'.
    meanBy(data.summaryStats, ({[keyName]: {value}}) => value),
  );
};

export const getPlacementDurationMean = memoize(_getPlacementDurationMean) as (
  arg1: RoiSummary,
) => number;

const getDaysInMonths = (days: number) =>
  prettifyNumber(days / NUM_DAYS_IN_MONTH);

export default PlacementDurationsChart;
